'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArrayService = function () {
  function ArrayService() {
    'ngInject';

    _classCallCheck(this, ArrayService);
  }

  _createClass(ArrayService, [{
    key: 'add',
    value: function add(array, obj) {
      return [].concat(_toConsumableArray(array), [obj]);
    }
  }, {
    key: 'remove',
    value: function remove(array, obj) {
      var index = array.indexOf(obj);

      if (index === -1) {
        throw new Error('Object does not exist in array!');
      }

      return [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1)));
    }
  }, {
    key: 'update',
    value: function update(array, obj, index) {
      if (index === -1) {
        throw new Error('Object does not exist in array!');
      }

      return [].concat(_toConsumableArray(array.slice(0, index)), [obj], _toConsumableArray(array.slice(index + 1)));
    }
  }]);

  return ArrayService;
}();

exports.default = ArrayService;


// WEBPACK FOOTER //
// ./services/array.service.js